import { useContext } from 'react';
import { AppContext } from '../../contexts/app/context';
import EditHOC from '../../hoc/EditHOC';
import CommentActionButton from './CommentActionButton';
import { DeleteIcon } from 'foundations-assets/icons/components/DeleteIcon';
import { EditIcon } from 'foundations-assets/icons/components/EditIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function CommentRowButtons({
  onEditComment,
  onDeleteComment,
  isCommentCreator
}) {
  const {
    isPastMeeting,
    appName
  } = useContext(AppContext);
  if (!isCommentCreator) {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(EditHOC, {
        isPastMeeting: isPastMeeting,
        children: /*#__PURE__*/_jsx(CommentActionButton, {
          icon: /*#__PURE__*/_jsx(EditIcon, {}),
          tooltipMessage: "editCommentsDisabled",
          isCommentCreator: isCommentCreator
        })
      }), /*#__PURE__*/_jsx(EditHOC, {
        isPastMeeting: isPastMeeting,
        children: /*#__PURE__*/_jsx(CommentActionButton, {
          icon: /*#__PURE__*/_jsx(DeleteIcon, {}),
          tooltipMessage: "editCommentsDisabled",
          isCommentCreator: isCommentCreator
        })
      })]
    });
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(EditHOC, {
      isPastMeeting: isPastMeeting,
      children: /*#__PURE__*/_jsx(CommentActionButton, {
        icon: /*#__PURE__*/_jsx(EditIcon, {}),
        tooltipMessage: "edit",
        dataTestId: `${appName}-comments-card-edit-button`,
        isCommentCreator: isCommentCreator,
        onClick: onEditComment
      })
    }), /*#__PURE__*/_jsx(EditHOC, {
      isPastMeeting: isPastMeeting,
      children: /*#__PURE__*/_jsx(CommentActionButton, {
        icon: /*#__PURE__*/_jsx(DeleteIcon, {}),
        tooltipMessage: "remove",
        dataTestId: `${appName}-comments-card-remove-button`,
        isCommentCreator: isCommentCreator,
        onClick: onDeleteComment
      })
    })]
  });
}
export default CommentRowButtons;